<ion-content padding no-bounce text-center>
    <app-header
    [iconName]="'menu'"
    [title]="null"
    [menuToggleRight]="true"
    [showErrorMessageNetwork]="true">
    </app-header>
    <div class="error-network" *ngIf="!isOnline()">
        <span class="error-network-container">
            <i class="icon-warning"></i>
            <span>{{"NoAccessInternet" | translate}}</span>
        </span>
    </div>
    <div class="choose-printer" *ngIf="showPrinterList">{{'SelectPrinter' | translate}}</div>
    <div *ngIf="showPrinterList">
        <ion-toolbar class="printer-list-actions-search-toolbar">
            <ion-searchbar
            class="printer-list-actions-searchbar"
            placeholder="{{'Search' | translate}}"
            show-clear-button="always"
            [debounce]="700"
            (ionInput)="onSearch($event)">
            </ion-searchbar>
        </ion-toolbar>
        @if (printerList.length < 1) {
            <div class="text-center mt40 pl20 pr20 height100">
                <div>{{"NoPrinterMatchDocuments" | translate}}</div>
            </div>
        } @else {
            <ion-list>
                <ion-item lines="none" class="queue-list-item" *ngFor="let printer of printerList">
                    <div class="printer-queue-container">
                        <button class="select-printer-clickzone printer-queue" (click)="choosePrinterToRegister(printer)">
                            <div class="printer-id queues-list printer-id--online pull-left">
                                <div>{{printer.signId}}</div>
                            </div>
                        </button>
                        <button class="select-printer-clickzone printer-queue text" (click)="choosePrinterToRegister(printer)">
                            <div class="queue-text pull-left">
                                <div class="queue-name">{{printer.name | sanitizeText}} </div>
                                <div class="printer-location" *ngIf="printer.location">{{printer.location | sanitizeText}}</div>
                            </div>
                        </button>
                        <button class="favorite-printer-clickzone printer-info" tappable (click)="presentModal('printerInfo', printer)">
                            <span class="favorite-printer-icon">
                                <i class="favorite-color info-icon">i</i>
                            </span>
                        </button>
                    </div>
                </ion-item>
            </ion-list>
        }
    </div>
    <div class="pagination-container" [ngClass]="{'iphone': isIPhone}" *ngIf="pagingObject.totalPages > 0 && showPrinterList && showPagination">
        <button class="btn btn-sm prev" (click)="currentPage > 0 ? getNextPage(true) : false" [disabled]="pagingObject.number === 0">
          <i class="icon-left-open"></i>
      </button>
      <span class="paging-numerics">{{pagingObject.number + 1}}/{{pagingObject.totalPages}}</span>
      <button class="btn btn-sm next" [disabled]="currentPage + 1 >= pagingObject.totalPages" (click)="getNextPage()">
          <i class="icon-right-open"></i>
      </button>
  </div>
</ion-content>